<template>
    <div class="new-budget-form">
        <form @submit.prevent="store" class="new-budget-form-container">
            <h2>{{ $t('Создание бюджета') }}</h2>

            <p>
                To create a budget, specify the name and accounts that will be taken into account when calculating this budget.
            </p>

            <p>
                After creating a budget, you can customize it by individually specifying data for each month.
            </p>

            <div class="form-group">
                <input type="text" :class="{'form-control': true, 'is-invalid': hasError('name')}" v-model="form.name" :placeholder="$t('Название')">

                <span class="invalid-feedback">{{ getError('name') }}</span>
            </div>

            <div class="form-group">
                <multiselect v-model="form.accounts" :multiple="true" :options="accounts" :placeholder="$t('Счета')" :custom-label="nameWithBalance" label="title" track-by="id" class="form-control">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.title }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>{{ $t('Счета') }}</span>
                        </div>
                    </template>
                </multiselect>

                <span class="invalid-feedback">{{ getError('accounts') }}</span>
            </div>

            <div class="info-tip">
                Оставьте список счетов пустым, если хотите взять в учет этого бюджета все существующие счета.
            </div>

            <div class="text-center">
                <button class="btn btn-blue btn-form">Создать</button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { EventBus } from '../../../event-bus';

export default {
    name: "NewBudgetForm",

    data: function() {
        return {
            form: {
                name: null,
                accounts: [],
            },

            errors: {},
        };
    },

    mounted() {
        this.loadAccounts();
    },

    watch: {
        'form.name': function() {
            delete this.errors['name'];
        },
        'form.accounts': function() {
            delete this.errors['accounts'];
        },
    },

    computed: {
        ...mapGetters(['accounts']),
    },

    methods: {
        ...mapActions(['loadAccounts']),
        
        nameWithBalance({ title, amount, currency }) {
            let balance = this.$options.filters.money(amount);

            return `${title} — ${balance} ${currency}`;
        },

        store() {
            this.$ga.event('budgetCreate', 'clicked');

            axios.post('/budget/create', this.form)
                .then(({data}) => {
                    EventBus.$emit('show-alert', data.message ? data.message : $t('Бюджет создан'), 'success');

                    this.$ga.event('budgetCreate', 'created');

                    this.$router.push(`/budget/${data.data.id}`);
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    },
}
</script>

<style scoped lang="scss">
.new-budget-form {
    .new-budget-form-container {
        background: #fff;
        width: calc(100% - 64px);
        border-radius: 5px;
        margin-bottom: 24px;
        padding: 24px 32px;

        @media (max-width: 768px) {
            background: transparent;
            padding: 0 24px;
            width: calc(100% - 48px);
            display: flex;
            flex-direction: column;
            height: 100%;

            .btn-form {
                margin-top: auto;
                margin-bottom: 24px;
            }
        }

        h2 {
            color: #152640;
            font-family: "Proxima Nova Lt";
            font-weight: 600;
            font-size: 18px;
            margin: 0;
            margin-bottom: 24px;
        }

        p {
            font-size: 14px;
            font-family: "Proxima Nova Rg";
            color: rgba(#152640, .5);
            margin-bottom: 16px;
        }

        input.form-control {
            width: calc(100% - 24px);
        }

        .info-tip {
            font-size: 14px;
            font-family: "Proxima Nova Rg";
            color: #359080;
            margin: 24px 0 32px;
        }
    }
}
</style>